export type UserInfo = {
  identitySerialNo: string;
  användarnamn?: string;
  namn: string;
  kanalbehörigheter: Kanalbehörighet[];
  arbetsgivarebehörigheter: Arbetsgivarebehörighet[];
  ärBehörig: boolean;
};

export type Kanalbehörighet = {
  kanaltyp: Kanaltyp;
  url: string;
};

export enum Kanaltyp {
  KpaDirektInformation = 0,
  KppNkd = 1, // KpaDirektPensionsadministration
  KppPv = 2, // KpaDirektPensionsvalet
};

export type Arbetsgivarebehörighet = {
  kundnummer: string;
  namn: string;
};
